import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { deleteProduct, productList } from "../../redux/CrudSlice";
import {
  Box,
  Button,
  CardActions,
  CardContent,
  Container,
  Grid,
  Typography,
  Pagination,
  Stack,
  Card,
} from "@mui/material";
import { imagePath } from "../../helper/Helper";
import { NavLink } from "react-router-dom";
import Swal from "sweetalert2";
function ProductList() {
  const { products, totalPage } = useSelector((state) => state.crudKey);
  const [totalRecords, setPage] = useState();
  const [deleteId, setDeleteId] = useState(null);
  const [isModal, setIsModal] = useState(false);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(productList());
  }, []);
  useEffect(() => {
    if (isModal) {
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "confirmButton",
          cancelButton: "cancelButton",
        },
        buttonsStyling: false,
      });
      swalWithBootstrapButtons
        .fire({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Yes, delete it!",
          cancelButtonText: "No, cancel!",
          reverseButtons: true,
        })
        .then((result) => {
          console.log(result);

          if (result.isConfirmed) {
            dispatch(deleteProduct({ id: deleteId })).then(() => {
              dispatch(productList());
            });
            swalWithBootstrapButtons.fire({
              title: "Deleted!",
              text: "Your file has been deleted.",
              icon: "success",
            });
            setIsModal(false);
          } else if (
            /* Read more about handling dismissals below */
            result.isDismissed === true ||
            result.isDenied === true
          ) {
            setIsModal(false);
            swalWithBootstrapButtons.fire({
              title: "Cancelled",
              text: "Your imaginary file is safe :)",
              icon: "error",
            });
          }
        });
    }
  }, [isModal]);

  const handleChange = (item, pagenuumber) => {
    setPage(pagenuumber);
    dispatch(
      productList({
        page: pagenuumber,
        perpage: 10,
      })
    );
  };
  const handleDelete = (id) => {
    setDeleteId(id);
    setIsModal(true);
  };
  useEffect(() => {
    if (deleteId) {
      // dispatch(deleteProduct({ id: deleteId }))
    }
  }, [deleteId]);

  return (
    <div>
      <Container maxWidth="lg">
        <Grid
          container
          spacing={2}
          style={{ marginTop: 10, alignItems: "center", justifyContent: "center" }}
        >
          {products?.map((item) => {
            return (
              <>
                <Grid item lg={3} md={4} sm={6}
                >
                  <Card>
                    <CardContent>
                      <Box
                        component="img"
                        sx={{
                          width: "100%",
                          height: "205px",
                          objectFit: "cover",
                          borderRadius: 2,
                        }}
                        alt="Example Image"
                        src={item.image ? imagePath(item.image) : "error"}
                      />
                      <Typography variant="h5" component="div">
                        {item.title}
                      </Typography>
                      <Typography variant="body2">{item.description}</Typography>
                    </CardContent>
                    <CardActions>
                      <CardActions style={{ display: "flex", width: "100%" }}>
                        <NavLink
                          style={{ textDecoration: "none", color: "#fff", width: "100%" }}
                          to={`/edit-product/${item._id}`}
                        >
                          <Button size="small" fullWidth variant="contained" style={{ color: "#fff" }}>
                            Edit
                          </Button>
                        </NavLink>
                        <Button
                          variant="outlined"
                          fullWidth
                          onClick={() => handleDelete(item._id)}
                          size="small"
                          style={{ color: "#000 !impotant" }}
                        >
                          Delete
                        </Button>
                      </CardActions>
                    </CardActions>
                  </Card>
                </Grid>
              </>
            );
          })}
        </Grid>
        <Stack alignItems="center" sx={{ marginTop: '50px' }}>
          <Pagination
            color="Primary"
            count={totalPage}
            onChange={handleChange}
            totalRecords={totalRecords}
          />
        </Stack>
      </Container>
    </div>
  );
}

export default ProductList;
